


























































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaymentReceiptResponse } from '@/models/payment/payment.response';
import { Base } from '@/components/common/base';
import { FileHelper as _file } from '@/helper/file.helper';
import {paymentService} from '@/shared';

@Component({
  computed: {
    partSaleApprovedPaymentDetail: {
      get() {
        const partsalesPayment = this.paymentResponse.paymentDetail.details.filter(
          (x) => x.status == 'Approved'
        );
        return partsalesPayment;
      },
    },
  },
})
export default class PartSalePaymentResponsePage extends Base {
  public loading: boolean = false;
  public errorMsg: string = '';
  public txHeaderId: string = '';
  public txDetailId: string = '';
  public paymentResponse: PaymentReceiptResponse = {};
  public requestProgress: boolean = false;
  public mounted() {
    this.txHeaderId = this.$route.query.txHeaderId as string;
    this.txDetailId = this.$route.query.txDetailId as string;
    if (this.txHeaderId && this.txDetailId) {
      this.getPaymentStatus(this.txHeaderId, this.txDetailId);
    } else {
      this.showAlert(
        false,
        this.$t('partSalesPaymentResponse.alertTransactionIdEmpty')
      );
    }
  }

  public async getPaymentStatus(
    txHeaderId: string,
    txDetailId: string
  ): Promise<void> {
    try {
      this.loading = true;
      const response = await paymentService.getSalePartPaymentResponse(
        txHeaderId,
        txDetailId
      );
      this.paymentResponse = response;
      if (
        this.paymentResponse.paymentDetail.status === 'Approved' ||
        this.paymentResponse.paymentDetail.status === 'PartialApproved'
      ) {
        // tslint:disable-next-line:max-line-length
        this.showAlert(true, this.$t('roPaymentResponse.alertPaymentSuccess'));
      } else {
        if (this.paymentResponse.paymentDetail.status != 'Pending') {
          this.showAlert(true, response.paymentDetail.status);
        }
      }
    } finally {
      this.loading = false;
    }
  }

  public parseVendorResponse(vendorString): any {
    return JSON.parse(vendorString || '{}');
  }

  public async downloadReceipt(payment): Promise<void> {
    try {
      this.requestProgress = true;
      const response = await paymentService.downloadPaymentReceipt(
        this.paymentResponse.paymentDetail.transactionHeaderId,
        payment.id,
        this.paymentResponse.invoiceNumber,
        'PartSale'
      );
      const bytes = _file.base64ToArrayBuffer(response.fileContent);
      _file.downloadBytes(bytes, '', response.fileDownloadName);
    } finally {
      this.requestProgress = false;
    }
  }
}
